<template lang="pug">
section.container.mt-10
  h2.text-center.text-ro-dark 了解设置 轻松游玩
  .row.mt-5.esay-section.text-ro-light
    .col-md-12
      .row.easy-point
        .col-md-6.d-flex.justify-content-center.align-items-center.flex-column.px-10
          div
            h5 服务器基本设置
            p
              | 开放普通三转、喵族、忍者、抢手上位职业
              br
              | 最大基本等级
              span.text-ro-dark.font-weight-bold
                |175
              | 级、职业
              span.text-ro-dark.font-weight-bold
                | 60
              | 级
              br
              | 最大攻击速度为
              span.text-ro-dark.font-weight-bold
                | 197
              br
              | 装备精炼最大值为
              span.text-ro-dark.font-weight-bold
                | 15
              br
              | 经验值倍率提升至
              span.text-ro-dark.font-weight-bold
                | 快速
              br
              | 装备掉落率提升至
              span.text-ro-dark.font-weight-bold
                | 较高
              br
              | 普通卡片掉落率提升至
              span.text-ro-dark.font-weight-bold
                | 合理
              br
              | MVP卡片掉落率提升至
              span.text-ro-dark.font-weight-bold
                | 平衡
              //- span.text-danger 999999
              //- |，可是單純只有傷害可以嗎?我们還提供了優良隊友媒合，減少你解任務的時間。
        .col-md-6.d-flex.justify-content-center.align-items-center
          img.img-fluid(src="http://res.99ro.top/web-assets/img/esay/d1.jpg", width="450px")
    .col-md-12
      .row.easy-point.flex-row-reverse
        .col-md-6.d-flex.justify-content-center.align-items-center.flex-column.px-10
          div
            h5 特色设置
            p
              | 結合多年玩家习惯和经验不断打磨
              br
              | 积累了许多可玩性极高的玩法设定
              br
              | 多样化的娱乐方式带您和朋友们一起享受游玩时光
              br
              span.text-ro-dark.font-weight-bold
                | 更多玩法请前往论坛攻略中查询
        .col-md-6.d-flex.justify-content-center.align-items-center
          img.img-fluid(src="http://res.99ro.top/web-assets/img/esay/d2.jpg", width="450px")
    .col-md-12
      .row.easy-point
        .col-md-6.d-flex.justify-content-center.align-items-center.flex-column.px-10
          div
            h5 头饰资源
            p
              | 超1000+以上的海量头饰资源任意制作！
              br
              | 包含众多官服热门头饰和众多Ro粉丝原创头饰。
              br
              span.text-ro-dark.font-weight-bold
                | 几乎所有头饰都能通过低门槛收集材料完成制作！
        .col-md-6.d-flex.justify-content-center.align-items-center
          img.img-fluid(
            src="http://res.99ro.top/web-assets/img/esay/img_localize.png",
            width="450px"
          )
    .col-md-12
      .row.flex-row-reverse.easy-point
        .col-md-6.d-flex.justify-content-center.align-items-center.flex-column.px-10
          div
            h5 与喜欢Ro的朋友们在一起
            p
              | 与朋友一起组队升级、打装备。
              br
              | 一起在各种难度的副本中配合通关，获得成就感。
              br
              | 在PvE / PvP / GvG中为自己和公会而战！
              br
              span.text-ro-dark.font-weight-bold
                | 获得专属的个人装备奖励和团队的荣耀
        .col-md-6.d-flex.justify-content-center.align-items-center
          img.img-fluid(src="http://res.99ro.top/web-assets/img/esay/a1.jpg", width="450px")
</template>

<style lang="scss" scoped>
$easy-color: #769bd3;

.esay-section,
.easy-point {
  position: relative;
}
.esay-section::before {
  position: absolute;
  content: "";
  top: 0;
  bottom: 0;
  left: 50%;
  border-left: 3px solid $easy-color;
  transform: translateX(-50%);
  @media (max-width: 768px) {
    left: 2%;
  }
}
.easy-point::before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  border: 3px solid $easy-color;
  background-color: #fff;
  transform: translateX(-50%);
  @media (max-width: 768px) {
    left: 2%;
  }
}
</style>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Esay.vue